module.exports = __webpack_public_path__ + "images/my_collect.svg";